import { styled } from 'next-yak'

import * as image from './image'
import * as link from './link'
import * as tag from './tag'

export const BaseUserLabelLink = styled(link.Base)`
  align-items: center;
  display: flex;
  text-decoration: none;
`

export const UserLabelLink = styled(BaseUserLabelLink)`
  ${tag.RoleTag} {
    margin-left: 3px;
  }
`

export const UserLabelLinkWithLabel = styled(BaseUserLabelLink)`
  ${image.Avatar} {
    margin-right: 8px;
  }
`

UserLabelLink.displayName = 'S.userLabel.UserLabelLink'

export const BaseUserLabel = styled.div`
  align-items: center;
  display: flex;
  text-decoration: none;
`

export const UserLabel = styled(BaseUserLabel)`
  ${image.Avatar} {
    margin-right: 0px;
  }

  ${tag.RoleTag} {
    margin-left: 0px;
  }
`

export const UserLabelWithLabel = styled(BaseUserLabel)`
  ${image.Avatar} {
    margin-right: 8px;
  }
`
UserLabel.displayName = 'S.userLabel.UserLabel'
